/*
 * Shared styles for the discussion-package files.
 */
import type {CSSProperties} from "aphrodite";

import {color} from "@khanacademy/wonder-blocks-tokens";
import {contentWidth, mediaQueries} from "@khan/shared-styles";

import {
    moduleHorizontalPadding,
    moduleHorizontalPaddingSmall,
} from "#modules-package/styles.ts";

export const avatarContainerDiameter = 48;
export const avatarFormSpace = 13;

export const borderColor = color.offBlack50;
export const errorBackgroundColor: string = color.fadedRed8;
export const secondaryBackgroundColor = color.offWhite;

export const border = `1px solid ${borderColor}`;

export const textareaMinHeight = 143;

export const notAButton: CSSProperties = {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    textAlign: "left",
    display: "inline-block",
    cursor: "pointer",
    borderRadius: "none",
};

export const separator: CSSProperties = {
    backgroundColor: color.offBlack16,
    height: 1,
    position: "relative",
    top: -1,
};

// Standard reusable styles for restricting the width of content, centering it, and adding a white background.
export const standardContentStyling: CSSProperties = {
    width: "100%",
    maxWidth: contentWidth + moduleHorizontalPadding * 2,
    marginLeft: "auto",
    marginRight: "auto",
    backgroundColor: color.white,

    [mediaQueries.xsOrSmaller]: {
        maxWidth: contentWidth + moduleHorizontalPaddingSmall * 2,
    },
};

// Used for the top-level discussion containers.
export const discussionContainer: CSSProperties = {
    ...standardContentStyling,
    paddingLeft: moduleHorizontalPadding,
    paddingRight: moduleHorizontalPadding,
};

// DiscussionList and DiscussionListAcceptedClarification styles.
export const listWrapper: CSSProperties = {
    // We repeat the standard styling in the listWrapper because elements with this
    // styling do not always exist within elements with discussionContainer.
    ...standardContentStyling,
    paddingTop: 32,

    [mediaQueries.xsOrSmaller]: {
        paddingLeft: 8,
        paddingRight: 8,
    },
};
export const clarificationsListHeader: CSSProperties = {
    marginBottom: 16,
};
export const postWrapper: CSSProperties = {
    marginBottom: 12,
};

// DicussionPost and DiscussionPostAcceptedClarification styles.
// Styles used for xsOrSmaller viewports and compact display mode (e.g. profile widget).
export const compactStyles = {
    outerRepliesContainer: {
        paddingLeft: 16,
        paddingRight: 16,
    },
    nameAndDatetime: {
        flexDirection: "column",
        alignItems: "flex-start",
    },
    datetime: {
        marginLeft: 0,
    },
    flagText: {
        display: "none",
    },
    answersList: {
        marginLeft: 16,
    },
} as const;

export const post: CSSProperties = {
    flexDirection: "row",
    alignItems: "flex-start",
};
export const everythingButTheAvatar: CSSProperties = {
    width: "100%",
};
export const postHeader: CSSProperties = {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
    marginLeft: 24,
};
export const nameAndDatetime: CSSProperties = {
    flexDirection: "row",
    alignItems: "flex-end",

    [mediaQueries.xsOrSmaller]: compactStyles.nameAndDatetime,
};
export const authorNickname: CSSProperties = {
    maxWidth: 200,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: color.offBlack,
};
export const datetime: CSSProperties = {
    marginLeft: 8,
    color: color.offBlack64,

    [mediaQueries.xsOrSmaller]: {
        marginLeft: 0,
    },
};
export const contentContainer: CSSProperties = {
    position: "relative",
    marginLeft: 24,
};
export const content: CSSProperties = {
    color: color.offBlack,
    padding: "8px 0",
    wordWrap: "break-word",
};
export const postFooter: CSSProperties = {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 24,
    height: 40,
};
export const tools: CSSProperties = {
    flexDirection: "row",
    alignItems: "center",
};
export const actionPickerMobile: CSSProperties = {
    [mediaQueries.mdOrLarger]: {
        display: "none",
    },
};
export const actionPickerDesktop: CSSProperties = {
    marginLeft: 8,
    [mediaQueries.smOrSmaller]: {
        display: "none",
    },
};
